import {  Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import {
  CompositeFilterDescriptor,
  process,
  State,
  DataResult
} from '@progress/kendo-data-query';

import {
  DataStateChangeEvent,
  GridComponent,
  CellClickEvent,
  FilterService,
  SelectionEvent
} from "@progress/kendo-angular-grid";

import {
  PS_Lst_Tasks_V2_Result,
  ScreenListsService,
  PafListsService,
  SharedDataService,
  LoggedUserService,
  Family,
  ContactStoredData,
  SimpleReponseResult,
  Profil,
  PafLabelDirective,
  SupplierStatut,
  SuppliersService,
} from 'ngx-paf-common';
import { forkJoin, Subscription } from 'rxjs';
import { WindowService } from '@progress/kendo-angular-dialog';


@Component({
  selector: 'lst-encours',
  templateUrl: './lst-encours.component.html',
  styleUrls: ['./lst-encours.component.scss']
})
export class LstEncoursComponent implements OnInit, OnDestroy {
  @ViewChild('grid') kendoGrid: GridComponent;

  public lstStatuts: SupplierStatut[] = [];
  public lstFamilies: Family[] = [];
  public lstProfils: Profil[] = [];
  subscriptions: Subscription[] = [];
  selectedSuppliers:PS_Lst_Tasks_V2_Result[]= [];
  userDatas: ContactStoredData[] = [];
  encoursResults: PS_Lst_Tasks_V2_Result[];
  gridData: DataResult;
  state: State = {
    skip: 0,
    take: 100
  };
  public gridPageableSettings: any = {
    pageSizes: [10, 20, 50, 100],
    position: 'top'
  }


  constructor(
    public windowService: WindowService,
    private suppliersSvc: SuppliersService,
    private screenListsSvc: ScreenListsService,
    private pafLists: PafListsService,
    private router: Router,
    private route: ActivatedRoute,
    public sharedDataSvc: SharedDataService,
    private loggedUserSvc: LoggedUserService) {
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => {
      if (sub != null && !sub.closed) sub.unsubscribe();
    });
  }

  
  ngOnInit(): void {
    //on charge les listes fixes
    if (this.sharedDataSvc.allListsLoaded) {
      this.loadFixedLists();
    }    
    this.subscriptions.push(
      this.sharedDataSvc.allListsLoadedChange.subscribe(res => {
        this.loadFixedLists();
      }));
    //on charge les listes variables et les données
    //et on attend que le profil soit chargé
    if (this.sharedDataSvc.profilLoaded) {
      this.loadIfProfilAllowed();
    }
    this.subscriptions.push(
      this.sharedDataSvc.loggedProfilChange.subscribe(res => {
        this.loadIfProfilAllowed();
      })
    );
  }

  checkScreenAccess(): Promise<void> {
    let promise: Promise<void> = new Promise<void>((resolve, reject) => {
      this.sharedDataSvc.checkProfilAccessPafSettings('EN_COURS') ? resolve() : reject('Votre profil ne vous autorise pas à accéder à cet écran');
    });
    promise.catch((error: string) => {
      this.sharedDataSvc.alert(error,
        (): void => {
          this.sharedDataSvc.redirectToDefaultScreen();
        });
    });
    return promise;
  }

  loadIfProfilAllowed(): void {
    this.checkScreenAccess()
      .then(() => {
        this.reloadVariableLists((): void => {
          this.search();
        });
      });
  }

  
  loadFixedLists(): void {
    this.lstFamilies = [...this.sharedDataSvc.families];
    this.lstStatuts = [...this.sharedDataSvc.supplierStatuts];
    this.lstFamilies.forEach((f: Family) => {
      (<any>f).Display = this.sharedDataSvc.familyLabel(f.Id);
    });
    this.lstFamilies.sortObject('Display');
    this.lstStatuts.forEach((s: SupplierStatut, index: number) => {
      (<any>s).traduction = this.sharedDataSvc.getLoadedLabel(s.LblCod);
    });
    this.lstStatuts.sortObject('traduction');
  }


  reloadVariableLists(callBack: () => any = null): void {
    this.userDatas = [];
    forkJoin([
      this.loggedUserSvc.LoggedUserStoredDatas(),
    ]).subscribe(results => {
      this.userDatas = results[0];
      if (callBack) callBack();
    }
    );
  }



  public reinit() {
    this.encoursResults = [];
    this.state = {
      skip: 0,
      take: 100
    };
    this.gridData = <DataResult>process(this.encoursResults, this.state);
    this.search();
  }



refreshGrid():void{
  setTimeout(() => {
    this.gridData = process(this.encoursResults, this.state);
  }, 0);
}


  public search(): void {
    this.selectedRow = null;
    this.selectedSuppliers = [];
    this.selectedSuppliersIds = [];
    this.sharedDataSvc.WindowLock();
    this.screenListsSvc.EncoursList()
      .subscribe((res: PS_Lst_Tasks_V2_Result[]) => {
        this.encoursResults = res;
        if ((this.state.skip || 0) > res.length) {
          this.state = {
            skip: 0,
            take: 10
          };
        }
        this.gridData = process(this.encoursResults, this.state);
        setTimeout((): void => { this.kendoGrid.autoFitColumns() }, 100);
      },
        (err:any) => { this.sharedDataSvc.alert(JSON.stringify(err), (): void => this.sharedDataSvc.WindowUnlock()) },
        (): void => this.sharedDataSvc.WindowUnlock()
      );
  }


  public familyClass(dataItem: Family, indented: boolean = false): any {
    let ngClass: any = this.pafLists.familyClass(dataItem.Id, this.lstFamilies);
    if (indented) {
      let familyLevel: number = this.pafLists.familyLevel(dataItem.Id, this.lstFamilies) + 1;
      ngClass['ml-' + familyLevel.toString()] = true;
    }
    return ngClass;
  }

  public familyLabel(dataItem: Family): string {
    return this.pafLists.familyLabel(dataItem.Id, this.lstFamilies, true);
  }
  public familyIcon(dataItem: Family): any {
    return this.pafLists.familyIcon(dataItem.Id, this.lstFamilies);
  }
  public familyIconClass(dataItem: Family): any {
    return this.pafLists.familyIconClass(dataItem.Id, this.lstFamilies);
  }

  selectedSuppliersIds:number[]=[];

  selectedRow: PS_Lst_Tasks_V2_Result = null;

  public selectRow(event: CellClickEvent): void {
    this.selectedRow = event.dataItem;
  }

  dblClickGridEvent(): void {
    if (!this.selectedRow) return;
    const url = this.router.createUrlTree([`supplier-details/${this.selectedRow.Id}/list-tasks`]);
    window.open(url.toString(), '_blank');
  }

  getSupplierLink(dataItem:PS_Lst_Tasks_V2_Result):string {
    return this.router.createUrlTree([`supplier-details/${dataItem.Id}/list-tasks`]).toString();
  }


  checkNgClass(fieldValue: string): any {
    return {
      'far': true,
      'fa-check-square': (fieldValue == 'O'),
      'fa-square': (fieldValue != 'O'),
    }
  }

  public gridFiltersChange(values: any[], filterService: FilterService, column: any): void {
    filterService.filter({
      filters: values.map((value) => ({
        field: column.field,
        operator: "eq",
        value,
      })),
      logic: "or",
    });
    this.kendoGrid.autoFitColumns();
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.gridData = process(this.encoursResults, this.state);
    this.kendoGrid.autoFitColumns();
  }

  // getAchFamCellDisplay(item:PS_Lst_Tasks_V2_Result) : string {
  //   let ret: string[] = ['<div class="d-flex flex-column align-items-center" style="width:100;">'];
  //   (item.AchFamVal||'').split('|') .forEach(achfam=> {
  //     ret.push('<div class="badge cell-'+ item.AchFamColor +'">' + achfam + '</div>');
  //   })
  //   ret.push('</div>');
  //   return ret.join('');
  // }

  //-------------------------------------
  // Filtres sur Grid

  public filterChange(filter: CompositeFilterDescriptor): void {
    this.state.filter = filter;
    let filterDatas: PS_Lst_Tasks_V2_Result[] = this.encoursResults;
    this.gridData = process(filterDatas, this.state);
  }

  cellClass(itemColor:string):string{
    return itemColor ? 'cell-'+itemColor :'';
  }


  get relancableSuppliers():PS_Lst_Tasks_V2_Result[]{
    return this.selectedSuppliers.filter(sup=> sup.StatutId==1);
  }

  gridSelectionChange(event:SelectionEvent){
    this.selectedSuppliers.push(...event.selectedRows.map(row=><PS_Lst_Tasks_V2_Result>row.dataItem));
    this.selectedSuppliers = this.selectedSuppliers.filter(s=>!event.deselectedRows.some(row=><PS_Lst_Tasks_V2_Result>row.dataItem==s));
  }

  btnRelancerClick() {
    if (this.relancableSuppliers.length==0) return;
    let msg:string;
    if (this.relancableSuppliers.length==1){
      msg=`Confirmez-vous la relance du fournisseur ${this.relancableSuppliers[0].SupplierName} ?`;
    } else {
      msg=`Confirmez-vous la relance des ${this.relancableSuppliers.length} fournisseurs sélectionnés ?`;
    }
    this.sharedDataSvc.confirm(msg,()=> this.RelanceValidationFournisseurs(this.relancableSuppliers),null);
  }

  RelanceValidationFournisseurs(suppliers :PS_Lst_Tasks_V2_Result[]){
    this.sharedDataSvc.WindowLock();
    let supplierIds:number[]=suppliers.map(sup=>sup.Id);
    forkJoin(supplierIds.map(supplierId=>this.suppliersSvc.RelanceValidationFournisseurs([supplierId])))
    .subscribe({
      next:(results:SimpleReponseResult[])=>{
        this.selectedSuppliersIds = this.selectedSuppliersIds.filter(id=>!supplierIds.some(item=>item==id));
        this.selectedSuppliers = this.selectedSuppliers.filter(s=>!supplierIds.some(item=>item==s.Id));
        let detail:SimpleReponseResult[] = <SimpleReponseResult[]>(results.map(r=>(<SimpleReponseResult[]>r.ExtendDatas)[0]));
        let msg=detail.filter(item=>!!item.Message).map(item=>item.Message).join('<BR />');
        if (!msg) msg='Relances effectuées';
        this.sharedDataSvc.alert(msg);
      },
      error:(reason)=>this.sharedDataSvc.alert(reason.error.message)
    });
  }
}
